<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-card elevation="4" color="#EFEBE9" class="px-3 pb-1">
        <span v-html="listingData">
          
        </span>

      </v-card>

      <vconfirm
        :confirmOption="confirmBox"
        @isConfirm="isConfirm"
        :dialogConfirm="dialogConfirm"
        :confirmLoading="confirmLoading"
      >
      </vconfirm>
    </v-container>
  </div>
</template>
<style scoped>

</style>
<script>
import axios from "axios";
import { get } from "vuex-pathify";


import vconfirm from "@/components/v-confirm";


import { showSnackbar } from "../util/globalActions";
export default {
  name: "ContactUsView",
  components: {  vconfirm },

  data: () => ({
    validEdit: false,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    confirmBox: {
      message: "",
      okCaption: "OK",
      cancelCaption: "Cancel",
      data: "",
    },
    dialogConfirm: false,
    confirmLoading: false,
    isConfirm: false,
    width: 700,
    tableLoading: false,
    loadingprofessor: false,
    valid: false,
    modal: false,
    fromDate: null,
    toDate: null,
    search: "",
    listingData: [],
    message: "",
    professors: [],
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headers: [],
  }),
  created() {
    
    
    this.showData();
  },
  mounted() {},
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),

  },
  watch: {
    
  },
  methods: {
    
    showData() {
      
      const self = this;
      self.tableLoading = true;
      

      axios({
        url: self.apiUrl + "api/common/contactus",
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.listingData = res.data.body;
          

          self.tableLoading = false;
          
        })
        .catch(function(err) {
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
    
  },
};
</script>
